jQuery(() => {
  var $modal = $('#chiefCropModal');
  if ($modal.length) {
    $modal.on('shown.bs.modal', function () {
      var $cropbox = $modal.find('#cropbox');
      if ($cropbox.length === 0) return;
      if ($cropbox.data('Jcrop')) {
        $cropbox.data('Jcrop').destroy();
      }
      var img = $cropbox.get(0);
      function initJcrop() {
        if (!img || img.naturalWidth === 0 || img.naturalHeight === 0) return;
        new AvatarCropper();
      }
      function tryInit() {
        if (img.naturalWidth > 0 && img.naturalHeight > 0) {
          initJcrop();
          return;
        }
        $cropbox.one('load', function () {
          setTimeout(initJcrop, 50);
        });
        setTimeout(function () {
          if (img.naturalWidth > 0 && img.naturalHeight > 0 && !$cropbox.data('Jcrop')) initJcrop();
        }, 400);
      }
      if (img.complete && img.naturalWidth > 0 && img.naturalHeight > 0) {
        setTimeout(function () { if (!$cropbox.data('Jcrop')) initJcrop(); }, 250);
      } else {
        tryInit();
      }
    });
    var currentTrocarObjectUrl = null;
    $modal.on('hidden.bs.modal', function () {
      if (currentTrocarObjectUrl) {
        (window.URL || window.webkitURL).revokeObjectURL(currentTrocarObjectUrl);
        currentTrocarObjectUrl = null;
      }
      var $cropbox = $modal.find('#cropbox');
      var holder = $cropbox.closest('.jcrop-holder').get(0);
      if (holder) {
        var grid = holder.querySelector('#chief-crop-grid-overlay');
        if (grid) grid.remove();
      }
      if ($cropbox.length && $cropbox.data('Jcrop')) {
        $cropbox.data('Jcrop').destroy();
      }
    });
    var trocarBtn = document.getElementById('chief_crop_trocar_foto');
    var cropAvatarInput = document.getElementById('chief_crop_avatar_input');
    if (trocarBtn && cropAvatarInput) {
      trocarBtn.addEventListener('click', function () { cropAvatarInput.click(); });
      cropAvatarInput.addEventListener('change', function () {
        var file = this.files && this.files[0];
        if (!file) return;
        if (currentTrocarObjectUrl) {
          (window.URL || window.webkitURL).revokeObjectURL(currentTrocarObjectUrl);
          currentTrocarObjectUrl = null;
        }
        var $cropbox = $modal.find('#cropbox');
        var img = $cropbox.length ? $cropbox.get(0) : null;
        if (!img) {
          var container = document.getElementById('cropbox_container');
          if (!container) return;
          img = document.createElement('img');
          img.id = 'cropbox';
          img.alt = 'Preview do recorte';
          img.style.cssText = 'display: block; max-width: 100%; height: auto; margin: 0 auto;';
          container.insertBefore(img, container.firstChild);
          $cropbox = $(img);
        }
        if ($cropbox.data('Jcrop')) {
          $cropbox.data('Jcrop').destroy();
        }
        var url = (window.URL || window.webkitURL).createObjectURL(file);
        currentTrocarObjectUrl = url;
        img.onload = function () {
          if (img.naturalWidth && img.naturalHeight) {
            setTimeout(function () {
              if (!$cropbox.data('Jcrop')) new AvatarCropper();
            }, 50);
          }
        };
        img.onerror = function () {
          currentTrocarObjectUrl = null;
          (window.URL || window.webkitURL).revokeObjectURL(url);
        };
        img.src = url;
        $modal.find('.chief-crop-choose-hint').addClass('d-none');
      });
    }
    var $cropForm = $('#edit_form_chief_crop');
    if ($cropForm.length && $cropForm.closest('#chiefCropModal').length) {
      $cropForm.on('submit', function (e) {
        e.preventDefault();
        var cropbox = document.getElementById('cropbox');
        var cropInput = document.getElementById('chief_crop_avatar_input');
        var hasImage = (cropbox && cropbox.naturalWidth > 0) || (cropInput && cropInput.files && cropInput.files.length > 0);
        if (!hasImage) {
          alert('Escolha uma foto antes de salvar.');
          return false;
        }
        var x = parseInt(document.getElementById('chief_crop_x').value, 10);
        var y = parseInt(document.getElementById('chief_crop_y').value, 10);
        var w = parseInt(document.getElementById('chief_crop_w').value, 10);
        var h = parseInt(document.getElementById('chief_crop_h').value, 10);
        if (!w || !h || w <= 0 || h <= 0) {
          alert('Ajuste o enquadramento da foto antes de salvar.');
          return false;
        }
        var form = this;
        var formData = new FormData(form);
        formData.append('_method', 'patch');
        var csrf = document.querySelector('meta[name="csrf-token"]');
        if (csrf) formData.append('authenticity_token', csrf.getAttribute('content'));
        var submitBtn = form.querySelector('#chief_crop_submit');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Salvando…';
        }
        var url = form.action;
        url += (url.indexOf('?') >= 0 ? '&' : '?') + 'format=json';
        fetch(url, {
          method: 'POST',
          body: formData,
          headers: { 'X-CSRF-Token': csrf ? csrf.getAttribute('content') : '', 'Accept': 'application/json' }
        }).then(function (res) {
          return res.text().then(function (text) {
            var data = {};
            try { data = (text && text.trim().length) ? JSON.parse(text) : {}; } catch (err) { data = {}; }
            if (res.ok) {
              var modalInstance = bootstrap.Modal.getInstance($modal.get(0));
              if (modalInstance) modalInstance.hide();
              var avatarImg = document.querySelector('.avatar-section .avatar-preview img');
              if (avatarImg && data.avatar_url) {
                avatarImg.src = data.avatar_url + (data.avatar_url.indexOf('?') >= 0 ? '&' : '?') + 't=' + Date.now();
              } else {
                window.location.reload();
              }
            } else {
              if (data.errors && data.errors.length) {
                alert(data.errors.join('\n'));
              } else {
                alert('Não foi possível salvar. Tente novamente.');
              }
            }
          }, function () {
            window.location.reload();
          });
        }).catch(function () {
          window.location.reload();
        }).finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Salvar';
          }
        });
        return false;
      });
    }
    return;
  }
  var $cropbox = $('#cropbox');
  if ($cropbox.length === 0) return;
  var img = $cropbox.get(0);
  function initJcrop() {
    if (img.naturalWidth === 0 || img.naturalHeight === 0) return;
    new AvatarCropper();
  }
  if (img.complete && img.naturalWidth > 0) {
    initJcrop();
  } else {
    $cropbox.on('load', initJcrop);
  }
});

class AvatarCropper {
  constructor() {
    this.update = this.update.bind(this);
    this.updatePreview = this.updatePreview.bind(this);
    var $cropbox = $('#cropbox');
    var w = $cropbox.get(0).naturalWidth;
    var h = $cropbox.get(0).naturalHeight;
    var size = Math.min(w, h, 500);
    var isModal = $cropbox.closest('#chiefCropModal').length > 0;
    if (isModal) {
      var dispW = Math.floor($cropbox.width()) || w;
      var dispH = Math.floor($cropbox.height()) || h;
      size = Math.min(size, dispW, dispH);
    }
    var opts = {
      aspectRatio: 1,
      setSelect: [0, 0, size, size],
      onSelect: this.update,
      onChange: this.update,
      allowResize: true
    };
    if (isModal) {
      opts.bgColor = 'black';
      opts.bgOpacity = 0.6;
      opts.addClass = 'jcrop-chief-modal';
    }
    $cropbox.Jcrop(opts);
    if (isModal) {
      var holder = $cropbox.closest('.jcrop-holder').get(0);
      if (holder) {
        var existing = holder.querySelector('#chief-crop-grid-overlay');
        if (existing) existing.remove();
        this.gridEl = document.createElement('div');
        this.gridEl.id = 'chief-crop-grid-overlay';
        this.gridEl.className = 'chief-crop-grid-overlay';
        this.gridEl.innerHTML = '<div class="jcrop-grid-line jcrop-grid-v1"></div><div class="jcrop-grid-line jcrop-grid-v2"></div><div class="jcrop-grid-line jcrop-grid-h1"></div><div class="jcrop-grid-line jcrop-grid-h2"></div>';
        holder.appendChild(this.gridEl);
        var api = $cropbox.data('Jcrop');
        if (api) {
          var sel = api.tellSelect();
          if (sel) this.update(sel);
        }
      }
    }
  }

  update(coords) {
    var $cropbox = $('#cropbox');
    var img = $cropbox.get(0);
    var imgOrignalWidth = img.naturalWidth;
    var imgOriginalHeight = img.naturalHeight;
    var imgResponsiveWidth = parseInt($cropbox.css('width'), 10) || imgOrignalWidth;
    var imgResponsiveHeight = parseInt($cropbox.css('height'), 10) || imgOriginalHeight;
    if (!imgResponsiveWidth || !imgResponsiveHeight) return;

    var responsiveX         = Math.ceil((coords.x/imgResponsiveWidth) * imgOrignalWidth);
    var responsiveY         = Math.ceil((coords.y/imgResponsiveHeight) * imgOriginalHeight);

    var responsiveW         = Math.ceil((coords.w/imgResponsiveWidth) * imgOrignalWidth);
    var responsiveH         = Math.ceil((coords.h/imgResponsiveHeight) * imgOriginalHeight);

    $('#chief_crop_x').val(responsiveX);
    $('#chief_crop_y').val(responsiveY);
    $('#chief_crop_w').val(responsiveW);
    $('#chief_crop_h').val(responsiveH);

    if (this.gridEl) {
      this.gridEl.style.left = coords.x + 'px';
      this.gridEl.style.top = coords.y + 'px';
      this.gridEl.style.width = coords.w + 'px';
      this.gridEl.style.height = coords.h + 'px';
    }
    return this.updatePreview(coords);
  }

  updatePreview(coords) {
  	return $('#preview').css({
  		width: Math.round((160/coords.w) * $('#cropbox').width()) + 'px',
  		height: Math.round((160/coords.h) * $('#cropbox').height()) + 'px',
  		marginLeft: `-${Math.round((160/coords.w) * coords.x)}px`,
  		marginTop: `-${Math.round((160/coords.h) * coords.y)}px`
  	});
	}
}